import axios from 'axios';
import { isSessionExpired, clearSession, getCurrentUser } from '../utils/authUtils';

const API_BASE_URL = 'https://boxy.currenmexico.com/legalback';
//const API_BASE_URL = 'http://localhost:3005/legalback';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para requests - agregar token automáticamente
api.interceptors.request.use(
  config => {
    const user = getCurrentUser();

    if (user && user.logg_express) {
      config.headers.Authorization = `Bearer ${user.logg_express}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Interceptor para responses - manejar errores de autenticación
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Si hay error 401 (No autorizado) o 403 (Prohibido)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Limpiar sesión y redirigir al login
      clearSession();
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export const loginClient = async (email, password) => {
  try {
    const response = await api.post('/client_login', {
      client_email: email,
      client_password: password,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const loginLawyer = async (email, password) => {
  try {
    const response = await api.post('/lawyer_login', {
      lawyer_email: email,
      lawyer_password: password,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const registerClient = async clientData => {
  try {
    console.log('data = ', clientData);

    const response = await api.post('/post_client', clientData);

    console.log('Response.data = ', response.data);

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getGenders = async () => {
  try {
    const response = await api.get('/get_gender');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getOccupations = async () => {
  try {
    const response = await api.get('/get_client_ocupation');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getHowYouMeet = async () => {
  try {
    const response = await api.get('/get_client_forma_conocernos');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Endpoints para catálogos de abogados
export const getCountries = async () => {
  try {
    const response = await api.get('/getcountries');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getStates = async (countryId = 142) => {
  try {
    const response = await api.get(`/getStates?country=${countryId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCities = async stateId => {
  try {
    const response = await api.get(`/getCities?state=${stateId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLawyerLanguages = async () => {
  try {
    const response = await api.get('/get_lawyer_languages');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLawyerPrices = async () => {
  try {
    const response = await api.get('/get_lawyer_precios');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLawyerSpecialties = async () => {
  try {
    const response = await api.get('/get_lawyer_especialidades');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLawyerPositions = async () => {
  try {
    const response = await api.get('/get_lawyer_position');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Nuevas funciones para catálogos de búsqueda (BuscaAbogado y ConsultaExpress)
export const getCatalogStates = async (countryId = 142) => {
  try {
    const response = await api.get(`/states?country=${countryId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCatalogCities = async stateId => {
  try {
    const response = await api.get(`/cities?state=${stateId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Registro de abogado
export const registerLawyer = async lawyerData => {
  try {
    const response = await api.post('/post_lawyer', lawyerData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Función para renovar token
export const refreshUserToken = async refreshToken => {
  try {
    const response = await api.post('/refresh_token', {
      refresh_token: refreshToken,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Función para logout en el servidor
export const logoutFromServer = async token => {
  try {
    const response = await api.post('/logout', { token });
    return response.data;
  } catch (error) {
    // No lanzar error si falla el logout del servidor
    console.warn('Error al hacer logout en servidor:', error);
    return { status: 0 };
  }
};
